import { AlertColor } from "@mui/material";
import { type FC } from "react";
import { FieldError } from "react-hook-form";
import { FormErrorMessage } from "../FormErrorMessage";

// fieldName is optional to keep backward compatibility. When provided, it enables auto-scroll utilities
// to locate the error element via [data-error-name="<fieldName>"] or #error-<fieldName>.
export const FormError: FC<{ error?: FieldError; fieldName?: string }> = ({ error, fieldName }) => {
    let severity: AlertColor = "error";

    if (error?.type === "warning") {
        severity = "warning";
    } else if (error?.type === "info") {
        severity = "info";
    } else if (error?.type === "success") {
        severity = "success";
    }

    if (error?.message) {
        return (
            <FormErrorMessage name={fieldName} severity={severity}>
                {error.message}
            </FormErrorMessage>
        );
    }
    return null;
};
